var signatureFieldPlaceholderProps = function signatureFieldPlaceholderProps(field) {
  return {
    x: field.x,
    y: field.y + field.height - 10,
    width: field.width,
    height: 8,
    css: {
      lineHeight: 1,
      fontSize: 8,
      fontStyle: 'italic',
      paddingLeft: 2
    },
    overflow: 'hidden'
  };
};

export { signatureFieldPlaceholderProps };